/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type MappingCellReferenceRow = {
  ref: string;
  direction: MappingCellReferenceRow.direction;
};
export namespace MappingCellReferenceRow {
  export enum direction {
    POSITIVE = 'positive',
    NEGATIVE = 'negative',
  }
}

